import { ConditionalFormConfig } from 'features/libra/stepComponents/conditionalForm/api/conditionalFormApi'
import { LibraWorflowStepComponentProps } from 'features/libra/workflow/workflowStepsApi'
import { FC } from 'react'

import {
  Component as ConditionalForm,
  useValidateConfig as useValidateConditionalFormConfig,
} from './ConditionalForm'

/**
 * FFS data-gathering step. Thin wrapper over `ConditionalForm` that the
 * workflow JSON's `dataGathering` substep references by name. Lives in
 * libra (not Rolodex) so the data-gathering step can grow FFS-specific
 * affordances later without re-uploading the workflow entry.
 *
 * Mounts under the asset workflow's per-component tabs (lifted to LibraView
 * at workspace level). `useWorkflowFieldValues` reads the active
 * `ComponentScopeContext` provided by `<UnitComponentTabs>` and persists to
 * `fieldValues.components[componentId]` via `useScopedFieldAccess`.
 */
export const Component: FC<
  LibraWorflowStepComponentProps<ConditionalFormConfig>
> = (props) => <ConditionalForm {...props} />

// Re-export ConditionalForm's `useValidateConfig` so the workflow framework
// can route malformed `dataGathering` configs through `WorkflowStepContainer`'s
// standard "Invalid Configuration" screen instead of letting ConditionalForm
// crash inside its Zod parse.
export const useValidateConfig = useValidateConditionalFormConfig
